import { Route, Routes } from 'react-router-dom';
import { AppRoutes } from './constants/routes';
import { Box } from '@mui/material';

import Homepage from './pages/home/homepage.component';
import TopNav from './components/navigation/top-nav/top-nav.component';
import About from './pages/about-page/about-page.component';
import Portfolio from './pages/portfolio/portfolio.component';
import PortfolioView from './pages/portfolio/porfolio-view/portfolio-view.component';
import Jobs from './pages/jobs/jobs.component';
import Footer from './components/footer/footer.component';

import { useAppStyles } from './App.styles.js';
import DrawerNav from './components/navigation/drawer-nav/drawer-nav.component';
import ContactUs from './pages/contact-us/contact-us.component';

function App() {
  const classes = useAppStyles();

  return (
    <>
      <TopNav />
      <Box className={classes.pageContainer}>
        <Box className={classes.contentWrap}>
          <Routes>
            <Route path={AppRoutes.HOME.route} element={<Homepage />} />
            <Route path={AppRoutes.ABOUT.route} element={<About />} />
            <Route path={AppRoutes.WORKS.route} element={<Portfolio />} />
            <Route
              path={`${AppRoutes.WORKS.route}/:slug`}
              element={<PortfolioView />}
            />
            <Route path={AppRoutes.JOBS.route} element={<Jobs />} />
            <Route path={AppRoutes.CONTACT_US.route} element={<ContactUs />} />
          </Routes>
        </Box>
        <Footer />
        <DrawerNav />
      </Box>
    </>
  );
}

export default App;
